import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "card",
  style: {"width":"100%"}
}
const _hoisted_2 = {
  class: "row",
  style: {"padding-top":"10px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_4 = { class: "col-md-12 col-lg-3" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "col-md-12 col-lg-7" }
const _hoisted_7 = { style: {"padding-top":"15px"} }
const _hoisted_8 = { id: "fechaC" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = {
  class: "badge bg-dark",
  id: "localidad"
}
const _hoisted_11 = {
  class: "card-body",
  id: "card-body"
}
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_14 = { class: "col-lg-11" }
const _hoisted_15 = { class: "card-title" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("b", null, "Mensaje:", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode()
const _hoisted_18 = { id: "problemas" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-lg-12",
    style: {"font-align":"center!important"}
  }, [
    /*#__PURE__*/_createElementVNode("h6", {
      class: "card-title",
      style: {"font-size":"12px!important","text-align":"center!important"},
      id: "correo2"
    })
  ])
], -1)
const _hoisted_20 = {
  class: "card-text",
  id: "descriptionReportes",
  "data-description": "prueba"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  id: "verCompleto",
  class: "btn btn-info btn-block verCompleto",
  "data-id": "2"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " done ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.device, (message) => {
    return (_openBlock(), _createElementBlock("div", {
      key: message.id,
      class: "col-xs-12 col-sm-12 col-md-3 col-lg-2 mt-2 ms-1"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              id: "imgStatus",
              style: {"width":"50px"},
              class: "cardimg-top img-responsive hidden-xs hidden-sm",
              src: {'message.status':_ctx.imgStatus},
              alt: "Card image cap"
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h6", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createTextVNode(_toDisplayString(_ctx.$filters.dateFormat(message.date)), 1),
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.device.phone_number), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h6", _hoisted_15, [
                _hoisted_16,
                _hoisted_17,
                _createElementVNode("span", _hoisted_18, _toDisplayString(message.text), 1)
              ])
            ])
          ]),
          _hoisted_19,
          _createElementVNode("p", _hoisted_20, [
            _createElementVNode("span", {
              class: _normalizeClass(["badge", {'message.attended_by':_ctx.texto_usuario}])
            }, _toDisplayString(_ctx.$filters.textoDefault("Sin Asignar",message.attended_by)), 3)
          ]),
          _hoisted_21
        ])
      ])
    ]))
  }), 128))
}